<template class="">
  <div
    v-if="visible"
    class="mx-4 mb-4 bg-red-100 border border-red-400 text-red-700 text-[14px] px-4 py-1 rounded relative"
    role="alert"
  >
    <!-- <strong class="font-bold">Error! </strong> -->
    <span class="block sm:inline">{{ message }}</span>
    <!-- <span class="absolute top-0 bottom-0 right-0 px-4 py-3" @click="close">
        <svg class="fill-current h-6 w-6 text-red-500" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M14.348 5.652a.999.999 0 1 0-1.414-1.414L10 7.172 7.066 4.238a.999.999 0 1 0-1.414 1.414L8.586 10l-2.934 2.934a.999.999 0 1 0 1.414 1.414L10 12.828l2.934 2.934a.999.999 0 1 0 1.414-1.414L11.414 10l2.934-2.934z"/></svg>
      </span> -->
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
    duration: {
      type: Number,
      default: 5000, // Default to 5 seconds
    },
  },
  data() {
    return {
      visible: true,
    };
  },
  mounted() {
    this.autoHide();
  },
  methods: {
    autoHide() {
      setTimeout(() => {
        this.visible = false;
        this.$emit("hidden");
      }, this.duration);
    },
    close() {
      this.visible = false;
      this.$emit("hidden");
    },
  },
};
</script>

<style scoped>
/* Add additional styling here if necessary */
</style>
